import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { VernostServiceService } from "../../services/vernost-service.service";
import { CryptoService } from "../../services/crypto-service.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  emailPattern =
    "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$";
  passwordPattern = "^[a-zA-z0-9]{6,}$";
  screen_details: any = [];
  user1: any = {};
  userEmail = false;
  parent_table = "mst_user";
  parent_table_Id = "USER_ID";
  USER_CODE = "USER_CODE";
  USER_FIRSTNAME = "USER_FIRSTNAME";
  USER_LASTNAME = "USER_LASTNAME";
  USER_EMAIL = "USER_EMAIL";
  USER_PASSWORD = "USER_PASSWORD";
  USER_ADDRESS = "USER_ADDRESS";
  USER_MOBILE = "USER_MOBILE";
  ROLE_ID = "ROLE_ID";
  returnUrl: string;
  errorUrl: string;
  navigationUrl: string;
  functionality_data: any = [];
  localhost_url: string;

  dbFields = [this.USER_EMAIL, this.USER_PASSWORD];
  formData: any = [];
  uid: any = "";
  constructor(
    private router: Router,
    private vernostService: VernostServiceService,
    private cryptoService: CryptoService
  ) { }

  ngOnInit() {
    this.screen_details = {
      EMAIL: "",
      PASSWORD: ""
    };
    this.uid = localStorage.getItem("uid");
    if (this.uid != undefined && this.uid != null && this.uid != "") {
      this.router.navigate(["/navigation"]);
    }
    this.userEmail = true;
    //  this.navigationUrl = '/navigation';
    //     this.localhost_url= 'http://localhost:4200';
    document.cookie = 'con_adopt=' + 'interxxxxxx'
  }

  submitdata() {
    this.returnUrl = "/navigation";
    this.errorUrl = "/login";
    if ((this.cryptoService.getCookie("con_adopt") == undefined)) {
      document.cookie = 'con_adopt=' + 'interxxxxxx'
    }

    var email = this.screen_details.EMAIL;
    var password = this.screen_details.PASSWORD;
    var regx = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;

    if (email == "") {
      document.getElementById("UserNameErr").innerHTML =
        "Please Enter UserName";
      document.getElementById("UserNameErr").style.color = "red";
    } else if (email != "" && regx.test(email) == false) {
      document.getElementById("UserNameErr").innerHTML = "Incorrect UserName";
      document.getElementById("UserNameErr").style.color = "red";
    } else {
      document.getElementById("UserNameErr").innerHTML = "";
    }
    if (password == "") {
      document.getElementById("passwordErr").innerHTML =
        "Please Enter Password";
      document.getElementById("passwordErr").style.color = "red";
    } else {
      document.getElementById("passwordErr").innerHTML = "";
    }
    if (email != "" && password != "" && this.userEmail == false) {
      //console.log("username is=====", email);
      //console.log("password is-==========", password);
      document.getElementById("error").innerHTML = "";
      var pwd = (this.cryptoService.encryptData(password))
      var array = {
        // parent_table: this.parent_table,
        // dbFields: this.dbFields,
        // parent_table_ID: this.parent_table_Id,
        email: email,
        password: pwd
      };
      this.vernostService.loginUserData(array).subscribe(response => {
        if (response[0].status == "Sucess") {
          var fname = response[0].result[0].USER_FIRSTNAME;
          var lname = response[0].result[0].USER_LASTNAME;
          var ucode = response[0].result[0].USER_CODE;
          var roleID = response[0].result[0].ROLE_ID;
          localStorage.setItem("fname", fname);
          localStorage.setItem("lname", lname);
          localStorage.setItem("ucode", ucode);
          localStorage.setItem("roleID", roleID);

          this.vernostService.loginUser(array).subscribe(loginResponse => {
            if (loginResponse[0].status == "Sucess") {
              if (loginResponse[0].result[0].length == 0) {
                this.router.navigate([this.errorUrl]);
              } else {
                this.navigationUrl = "/navigation";
                this.functionality_data = loginResponse[0].result[0];
                var uid = loginResponse[0].result[0][0].USER_ID;
                let userinfos = {
                  first_name: loginResponse[0].result[0][0].USER_FIRSTNAME,
                  last_name: loginResponse[0].result[0][0].USER_LASTNAME,
                  user_code: loginResponse[0].result[0][0].USER_CODE
                };

                localStorage.setItem("uid", uid);
                sessionStorage.setItem("uid", uid);
                sessionStorage.setItem("userinfo", JSON.stringify(userinfos));
                this.router.navigate([this.returnUrl]);
              }
            }
          });
        } else {
          if (response[0].status == "userErr") {
            document.getElementById("UserNameErr").innerHTML =
              response[0].message;
            document.getElementById("UserNameErr").style.color = "red";
          }
          if (response[0].status == "passwordErr") {
            document.getElementById("passwordErr").innerHTML =
              response[0].message;
            document.getElementById("passwordErr").style.color = "red";
          }
        }
      });
    }
  }

  clearErroMassages(id) {
    if (id == 1) {
      document.getElementById("UserNameErr").innerHTML = "";
    }
    if (id == 2) {
      document.getElementById("passwordErr").innerHTML = "";
    }
  }
  checkUserLength() {
    this.userEmail = false;
    document.getElementById("error").innerHTML = "";
  }

  onInputPassword() {
    document.getElementById("error").innerHTML = "";
  }

  checkEmailNames(data) {
    var regx = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;

    if (data != "" && regx.test(data) == false) {
      // console.log("OUT");
      document.getElementById("UserNameErr").innerHTML = "Incorrect Username";
      document.getElementById("UserNameErr").style.color = "red";
      this.userEmail = true;
    } else {
      document.getElementById("UserNameErr").innerHTML = "";
      this.userEmail = false;
    }
  }

  emptyValidation(data, id) {
    if (id == 1) {
      if (data == "") {
        document.getElementById("UserNameErr").innerHTML = "";
      }
    } else {
      if (data == "") {
        document.getElementById("passwordErr").innerHTML = "";
      }
    }
  }
}
